
import TestInstructionsStepSevenComponent from "@/components/Shared/RegisterTest/TestInstructionsStepSeven/TestInstructionsStepSevenComponent";
export default TestInstructionsStepSevenComponent;
